module.exports = __webpack_public_path__ + "media/images/emblems/Dardagny-coat_of_arms-6499845ded8f493e9dc32235a411fdbe.svg";